<template>
  <VSnackbar
    :model-value="snackbar"
    color="primary"
    :location="mobile ? 'bottom center' : 'bottom'"
    :timeout="-1"
    rounded="lg"
    elevation="24"
    class="text-justify"
    vertical
  >
    <VContainer fluid>
      <div :class="mobile ? 'font-weight-bold text-body-3' : 'font-weight-bold text-justify text-body-1'">
        {{ $t('cookies.presentation') }}
      </div>

      <Transition name="bounce">
        <VContainer v-if="showOptions" style="width: 100%;">
          <VDivider class="mt-2" />
          <VSwitch
            v-model="cookie.necessary"
            :label="$t('cookies.necessary_label')"
            readonly
            color="warning"
          />
          {{ $t('cookies.necessary') }}
          <VSwitch
            v-model="cookie.statistics"
            :label="$t('cookies.statistics_label')"
            color="warning"
          />
          {{ $t('cookies.statistics') }}
        </VContainer>
      </Transition>
    </VContainer>

    <VDivider />

    <template #actions>
      <div class="text-center">
        <VBtn
          color="error"
          class="mt-2 font-weight-bold mb-4 text-white"
          @click="$emit('cookie-reject')"
        >
          <VIcon class="mr-3">mdi-alert-circle</VIcon>
          {{ $t('cookies.discord') }}
        </VBtn>

        <VBtn
          color="warning"
          class="mt-2 mx-4 font-weight-bold mb-4 text-white"
          @click="showOptions = !showOptions"
        >
          <VIcon class="mr-3">mdi-cog</VIcon>
          {{ $t('cookies.options') }}
        </VBtn>

        <VBtn
          class="mt-2 font-weight-bold mb-4"
          variant="outlined"
          color="#C7D3DC"
          @click="$emit('cookie-accept', cookie)"
        >
          <VIcon class="mr-3">mdi-cookie</VIcon>
          {{ $t('cookies.agree') }}
        </VBtn>
      </div>
    </template>
  </VSnackbar>
</template>

<script>
export default {
  name: 'CookieBar',
  props: {
    snackbar: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      mobile: false,
      showOptions: false,
      cookie: {
        necessary: true,
        statistics: true,
      },
    }
  },
  beforeMount () {
    this.checkMobile()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.checkMobile()
    },
    checkMobile () {
      this.mobile = screen.width <= 760
    },
  },
}
</script>

<style>
@media(max-width: 850px){
  /* Vuetify 3 classes */
  .v-snackbar__actions {
    width: 100% !important;
    margin: auto !important;
    display: block !important;
  }
}

.v-snackbar__content{
  width: 100% !important;
}

/* animação */
.bounce-enter-active { animation: bounce-in 0.5s; }
.bounce-leave-active { animation: bounce-in 0.5s reverse; }
@keyframes bounce-in {
  0% { transform: scale(0); }
  50% { transform: scale(1.25); }
  100% { transform: scale(1); }
}
</style>
